const VIEW = Object.freeze({
  CLONE: "clone",
  CREATE: "create",
  EDIT: "edit",
});

function isValidViewType(viewType) {
  return Object.values(VIEW).includes(viewType);
}

export { isValidViewType, VIEW };
